<nav class="navbar navbar-expand-lg navbar-light px-0 ">

  <a class="navbar-brand" href="#">
    <img class="logo-img" src="../../../assets/img/Logo-white.svg" />
  </a>
  <!-- <div [ngClass]="currentLang == 'en' ? 'p-beta-right' : 'p-beta-left'" class="beta">{{'beta' | translate}}</div> -->
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <i class="fa fa-bars" aria-hidden="true"></i>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul [ngStyle]="{'direction':currentLang == 'en' ? 'ltr' : 'rtl'}"
      class="navbar-nav w-100 mr-auto justify-content-around">
      <li *ngIf="!isLoggedIn  && !search" class=" nav-item user-account" data-toggle="collapse"
        data-target=".navbar-collapse.show">
        <a [routerLink]="['/auth']" routerLinkActive="router-link-active">
          {{'login'|translate}}
          <i class="user-account-icon fas fa-user-circle"></i>
        </a>
      </li>
      <li *ngIf="isLoggedIn && userInfo && !search" class="nav-item dropdown user-account" data-toggle="collapse"
        data-target=".navbar-collapse.show ">
        <a class="nav-link user-info " *ngIf="innerWidth > 768" routerLinkActive="router-link-active"
          [routerLink]="['/pages/profilePage']" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{userInfo.name}}
          <i class="user-account-icon fas fa-user-circle"></i>
        </a>
        <a class="nav-link   user-info" *ngIf="innerWidth <= 768" routerLinkActive="router-link-active"
          id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{userInfo.name}}
          <i class="user-account-icon fas fa-user-circle"></i>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a *ngIf="innerWidth <= 768" class="dropdown-item user-info " data-toggle="collapse"
            [routerLink]="['/pages/profilePage']"> {{userInfo.name}}</a>
          <a class="dropdown-item" data-toggle="collapse" (click)="logout()">{{'logout' | translate}}</a>
        </div>
      </li>
      <li [ngStyle]="{'display':currentLang == 'en'? ' inline' : 'none' }" *ngIf="!search"
        class="nav-item user-language" data-toggle="collapse" data-target=".navbar-collapse.show">
        <a (click)="navigateToArabic()">
          AR
        </a>
      </li>
      <li *ngIf="!search" class="nav-item user-language engLang" data-toggle="collapse"
        data-target=".navbar-collapse.show"
        [ngStyle]="{ 'display':currentLang == 'ar'? ' inline' : 'none' , 'margin-left':currentLang == 'en'  ? '1%' : '0','margin-right' :currentLang == 'en'  ? '1%' : '0',
       'border-left':currentLang == 'ar' ? '0px' : '1px solid white' , 'padding-left':currentLang == 'en'  ? '10px' : '0' }">
        <a (click)="navigateToEnglish()">
          EN
        </a>
      </li>
      <li class="nav-item searchArea justify-content-center dropdown" style="margin-right: 5px;">

        <input class="searchAreaBox {{search ? 'show' : ''}}"
          [ngStyle]="{'display': search ? 'inline' : 'none' ,'text-align':currentLang == 'ar'  ? 'right' : 'left',
        'border-right':currentLang == 'ar'  ? '1px solid #fff' : '0','border-left':currentLang == 'en'  ? '1px solid #fff' : '0' }"
          placeholder="{{'searchPlaceholder' | translate}}" (keydown.enter)="onEnterSearch($event)" aria-label="Search">
        <a class="nav-link " aria-haspopup="true" aria-expanded="false" (click)="search = !search">
          <i class="fas fa-search"></i>
        </a>
      </li>
      <li *ngFor="let menu of menuItems" class="nav-item dropdown" data-toggle="collapse"
        data-target=".navbar-collapse.show">
        <a [ngStyle]="{'background-position' : currentLang == 'en' ? ' 100% 18px' : '' }"
          class="nav-link dropdown-toggle px-3"
          [routerLink]="menu.slug ? ['/pages/'+menu.slug]: ['/pages/page/'+menu.slug+'/'+menu.id] "
          routerLinkActive="router-link-active" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{ currentLang == 'ar' ? menu.title : menu.title_en }}
        </a>
        <div *ngIf="menu.pages.length > 0" class="dropdown-menu" aria-labelledby="navbarDropdown">
          <ng-container *ngFor="let page of menu.pages">
            <a class="dropdown-item" data-toggle="collapse"
              (click)="navToSubMenu(menu.slug,page.slug,page.id, page.old, page)">{{ currentLang == 'ar' ? page.title :
              page.title_en }}</a>
            <!-- <a class="dropdown-item" data-toggle="collapse" *ngIf="page.external_url" [href]="page.external_url">{{
              currentLang == 'ar' ? page.title :
              page.title_en }}</a> -->
          </ng-container>

        </div>
      </li>




    </ul>
  </div>

</nav>